import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=5c3a81f2&scoped=true"
import script from "./Dropdown.js?vue&type=script&lang=js&external"
export * from "./Dropdown.js?vue&type=script&lang=js&external"
import style0 from "./Dropdown.scss?vue&type=style&index=0&id=5c3a81f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a81f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
